import { AGENT_SUBMIT_APPEAL_BEGIN, AGENT_SUBMIT_APPEAL_SUCCESS, AGENT_SUBMIT_APPEAL_FAILURE } from "./types";
import { checkNestedObject } from "utils/checkNestedObject";
import API from "../../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const submitAppeal = (payload) => async (dispatch, getState) => {
  dispatch({ type: AGENT_SUBMIT_APPEAL_BEGIN });
  try {
    if (checkNestedObject(getState(), "form", "appealForm", "values")) {
      const {
        appealReason,
        appealReasonOther,
      } = getState().form.appealForm.values;
      
      const data = {
        uniqueTxnId: payload.uniqueTxnId,
        appealType: payload.requestType,
        appealReason: undefined !== appealReasonOther && null !== appealReasonOther ? appealReasonOther : appealReason,
        appealState: payload.state,
        identifier: "mtn", value: payload.mtn
      };

      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          data[key] = data[key].trim();
        }
      }

      const response = await API({
        method: "POST",
        url: ENDPOINTS.AGENT_SUBMIT_APPEAL_FORM,
        data
      });

      if (response && response.status === "OK") {
        dispatch({ type: AGENT_SUBMIT_APPEAL_SUCCESS });
      } else {
        dispatch({ type: AGENT_SUBMIT_APPEAL_FAILURE });
      }
    }
  } catch (error) {
    dispatch({
      type: AGENT_SUBMIT_APPEAL_FAILURE,
      payload: error.response.description
    });
  }
};
